import React from "react";
import { forwardRefAs, Generic } from "../../base";
export const TableHead = forwardRefAs((props, ref) => React.createElement(Generic, Object.assign({ ref: ref }, props)), { as: "thead" });
TableHead.displayName = "Table.Head";
//# sourceMappingURL=table-head.js.map